'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDnd = require('react-dnd');

var _reactBootstrap4Modal = require('react-bootstrap4-modal');

var _itemType = require('../itemType');

var _itemType2 = _interopRequireDefault(_itemType);

var _AddLinkButton = require('../containers/AddLinkButton');

var _AddLinkButton2 = _interopRequireDefault(_AddLinkButton);

var _NavigationItemList = require('./NavigationItemList');

var _NavigationItemList2 = _interopRequireDefault(_NavigationItemList);

var _propTypes3 = require('../propTypes');

var _SectionDisclosureTriangle = require('../containers/SectionDisclosureTriangle');

var _SectionDisclosureTriangle2 = _interopRequireDefault(_SectionDisclosureTriangle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var navigationItemDragSource = {
  beginDrag: function beginDrag(props) {
    return props.navigationItem;
  }
};

var navigationItemDropTarget = {
  canDrop: function canDrop(props, monitor) {
    var dragItem = monitor.getItem();
    var dragItemType = (0, _itemType2.default)(dragItem);
    var myItemType = (0, _itemType2.default)(props.navigationItem);
    var iAmInANavigationSection = props.navigationItem.navigation_section_id;

    // Can't drop a section onto a link that's already in a section
    if (dragItemType === 'Section' && myItemType === 'Link' && iAmInANavigationSection) {
      return false;
    }

    // Links can swap with other links, so don't allow drops except directly onto an item
    if (dragItemType === 'Link' && !monitor.isOver({ shallow: true })) {
      return false;
    }

    return true;
  },
  hover: function hover(props, monitor) {
    var dragItem = monitor.getItem();

    if ((0, _itemType2.default)(props.navigationItem) === 'Section' && (0, _itemType2.default)(dragItem) === 'Link' && !props.navigationItem.expanded) {
      props.onExpand();
    }
  },
  drop: function drop(props, monitor) {
    if (!monitor.canDrop()) {
      return;
    }

    var dragItem = monitor.getItem();

    if (props.navigationItem.id === dragItem.id) {
      return;
    }

    if ((0, _itemType2.default)(props.navigationItem) === 'Section' && (0, _itemType2.default)(dragItem) === 'Link' && props.navigationItem.expanded) {
      props.onMoveNavigationItemInto(dragItem, props.navigationItems);
    } else {
      props.onMoveNavigationItemOnto(dragItem, props.navigationItems);
    }
  }
};

function collectNavigationItemDrag(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

function collectNavigationItemDrop(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

var NavigationItem = (_dec = (0, _reactDnd.DragSource)('NAVIGATION_ITEM', navigationItemDragSource, collectNavigationItemDrag), _dec2 = (0, _reactDnd.DropTarget)('NAVIGATION_ITEM', navigationItemDropTarget, collectNavigationItemDrop), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(NavigationItem, _React$Component);

  function NavigationItem(props) {
    _classCallCheck(this, NavigationItem);

    var _this = _possibleConstructorReturn(this, (NavigationItem.__proto__ || Object.getPrototypeOf(NavigationItem)).call(this, props));

    _this.onClickDelete = function () {
      _this.setState({ isConfirmingDelete: true });
    };

    _this.cancelDelete = function () {
      _this.setState({ isConfirmingDelete: false });
    };

    _this.confirmDelete = function () {
      _this.props.onDelete();
    };

    _this.renderDisclosureTriangle = function () {
      if ((0, _itemType2.default)(_this.props.navigationItem) !== 'Section') {
        return null;
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_SectionDisclosureTriangle2.default, { navigationItemId: _this.props.navigationItem.id }),
        ' '
      );
    };

    _this.renderConfirmDelete = function () {
      return _react2.default.createElement(
        _reactBootstrap4Modal.ConfirmModal,
        {
          visible: _this.state.isConfirmingDelete,
          onCancel: _this.cancelDelete,
          onOK: _this.confirmDelete
        },
        'Are you sure you want to delete ',
        _this.props.navigationItem.title,
        ' from the navigation bar?'
      );
    };

    _this.renderSectionItems = function () {
      if ((0, _itemType2.default)(_this.props.navigationItem) !== 'Section' || !_this.props.navigationItem.expanded) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'w-100 mt-2' },
        _react2.default.createElement(_NavigationItemList2.default, {
          baseUrl: _this.props.baseUrl,
          navigationItems: _this.props.navigationItems,
          navigationSectionId: _this.props.navigationItem.id
        }),
        _react2.default.createElement(
          'ul',
          { className: 'list-inline mt-2' },
          _react2.default.createElement(
            'li',
            { className: 'list-inline-item' },
            _react2.default.createElement(_AddLinkButton2.default, { navigationSectionId: _this.props.navigationItem.id })
          )
        )
      );
    };

    _this.renderItemContent = function () {
      var navigationItem = _this.props.navigationItem;


      return _react2.default.createElement(
        'div',
        { className: 'row w-100' },
        _react2.default.createElement(
          'div',
          { className: 'col' },
          _this.renderDisclosureTriangle(),
          _react2.default.createElement(
            'strong',
            null,
            (0, _itemType2.default)(navigationItem),
            ':'
          ),
          ' ',
          navigationItem.title
        ),
        _react2.default.createElement(
          'div',
          { className: 'col text-right' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-secondary btn-sm', onClick: _this.props.onEdit },
            'Edit'
          ),
          ' ',
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger btn-sm', onClick: _this.onClickDelete },
            'Delete'
          )
        )
      );
    };

    _this.render = function () {
      var _this$props = _this.props,
          connectDragSource = _this$props.connectDragSource,
          connectDropTarget = _this$props.connectDropTarget,
          isDragging = _this$props.isDragging;


      return connectDragSource(connectDropTarget(_react2.default.createElement(
        'li',
        { className: (0, _classnames2.default)('list-group-item draggable', { dragging: isDragging }) },
        _this.renderItemContent(),
        _this.renderSectionItems(),
        _this.renderConfirmDelete()
      )));
    };

    _this.state = {
      isConfirmingDelete: false
    };
    return _this;
  }

  return NavigationItem;
}(_react2.default.Component), _class2.propTypes = {
  navigationItem: _propTypes3.NavigationItemPropType.isRequired,
  navigationItems: _propTypes3.NavigationItemStorePropType.isRequired,
  onDelete: _propTypes2.default.func.isRequired,
  onEdit: _propTypes2.default.func.isRequired,
  baseUrl: _propTypes2.default.string.isRequired,

  // These come from @DragSource and @DropTarget

  connectDragSource: _propTypes2.default.func.isRequired,
  connectDropTarget: _propTypes2.default.func.isRequired,
  isDragging: _propTypes2.default.bool.isRequired,

  // These are used only by the drag/drop stuff above, and eslint incorrectly thinks they're
  // unused

  // eslint-disable-next-line react/no-unused-prop-types
  onExpand: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  onMoveNavigationItemInto: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  onMoveNavigationItemOnto: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = NavigationItem;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/NavigationItem.js
// module id = 410
// module chunks = 0